// @flow
import React from 'react';
import { Icon } from '@finect/tabular-components/Icon';
import { Container } from '@finect/tabular-core/Container';
import { ContainerInner } from '@finect/tabular-core/ContainerInner';
import { Follow } from '@finect/tabular-components/Follow';
import { Flex } from '@finect/tabular-core/Flex';
import { Settings } from '@finect/tabular-icons/settings';
import { Edit2 } from '@finect/tabular-icons/edit-2';
import { Mail } from '@finect/tabular-icons/mail';
import { connect } from 'react-redux';
import { AppLink } from '@finect/tabular-core/AppLink';
import { getBaseURL } from '@finect/front-utils/env';
import { HTML } from '@finect/tabular-components/HTML';

import {
  InnerBackground,
  IconBlock,
  InfoBlock,
  SponsorText,
  NameBlock,
  Name,
  HeadlineBlock,
  ProfileExtra,
  ProfileActions,
  ConfigButton,
  WriteButton,
  MessageButton,
  InnerContent
} from './partials';

const mapStateToProps = state => ({
  onlineMembers: state.conversations.onlineMembers
});

export const GroupProfileHeading = ({
  withH1 = false,
  profile,
  user,
  subscriptionsProfiles,
  onFollow,
  onlineMembers,
  withLink = false,
  withDescription = true,
  withBorder = false
}: {
  withH1?: boolean,
  profile: Object,
  user: Object,
  subscriptionsProfiles: Array<string>,
  onFollow: Function,
  onlineMembers: Array<string>,
  withLink: boolean,
  withDescription: boolean,
  withBorder: boolean
}) => {
  const isClient = Boolean(profile.socialStats.tags.find(({ id }) => id === '40014' || id === '40015'));
  return (
    <>
      <InnerBackground cover={profile.cover} />
      <Container style={{ padding: '0' }}>
        <ContainerInner>
          <InnerContent withBorder={withBorder} withDescription={withDescription}>
            <Flex>
              <IconBlock>
                <Icon
                  isOnline={onlineMembers.includes(profile.id)}
                  size={7}
                  alt={profile.displayName}
                  image={profile.icon ? `/image/${profile.icon}` : null}
                  margin="0 18px 0 0"
                  verified={false}
                />
              </IconBlock>

              <InfoBlock center={!withDescription}>
                <div>
                  <NameBlock {...(withLink ? { as: 'a', href: profile.web } : {})}>
                    <Name as={withH1 ? 'h1' : 'h4'} large>
                      {profile.displayName}
                    </Name>
                  </NameBlock>

                  {withDescription && (
                    <HeadlineBlock>
                      <HTML html={profile.description} />
                    </HeadlineBlock>
                  )}
                </div>

                {user.isLoggedIn && user.id === profile.id && (
                  <ProfileExtra>
                    <div></div>
                    <ProfileActions>
                      <Flex>
                        <WriteButton
                          as="a"
                          href={`/usuario/${profile.alias}/articulos/nuevo`}
                          secondary
                          variant="medium"
                        >
                          <Edit2 size="20" />
                          {`Escribir artículo`}
                        </WriteButton>

                        <ConfigButton as="a" href="/usuario/configuracion" variant="medium">
                          <Settings size="20" strokeWidth="2" />
                        </ConfigButton>
                      </Flex>
                    </ProfileActions>
                  </ProfileExtra>
                )}
              </InfoBlock>
            </Flex>

            {!(user.isLoggedIn && user.id === profile.id) && (
              <Flex>
                <Flex>
                  <MessageButton
                    variant="medium"
                    as={AppLink}
                    secondary
                    rel="nofollow"
                    href={`${getBaseURL()}/mensajes/nuevo?members=${profile.id}`}
                  >
                    <Mail size="20" />
                    {'Enviar mensaje'}
                  </MessageButton>

                  <Follow
                    follow={() =>
                      onFollow('profile', 'subscribe', profile.id, !subscriptionsProfiles.includes(profile.id), profile)
                    }
                    following={subscriptionsProfiles.includes(profile.id)}
                    // followers={profile.stats.subscribers}
                  />
                </Flex>
                {isClient && <SponsorText>Espacio patrocinado</SponsorText>}
              </Flex>
            )}
          </InnerContent>
        </ContainerInner>
      </Container>
    </>
  );
};
export default connect(mapStateToProps, null)(GroupProfileHeading);
